var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWellnessbeauty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-wellness_beauty",
    "data-name": "ic-wellness&beauty",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18405",
    "data-name": "Rectangle 18405",
    width: 32.543,
    height: 29.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18410",
    "data-name": "Rectangle 18410",
    width: 25.371,
    height: 22.882
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39711",
    "data-name": "Path 39711",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39714",
    "data-name": "Path 39714",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71363",
    "data-name": "Group 71363",
    transform: "translate(-1200.104 -715.64)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71334",
    "data-name": "Group 71334",
    transform: "translate(1213.679 733.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71333",
    "data-name": "Group 71333",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35727",
    "data-name": "Path 35727",
    d: "M8.862,74.427c-.639,0-1.278,0-1.917,0a.633.633,0,0,1-.712-.709c0-.282-.011-.564,0-.846A1.126,1.126,0,0,0,5.7,71.829a19.155,19.155,0,0,1-3.256-2.8,5.993,5.993,0,0,1-1.136-2.111A26.094,26.094,0,0,1,.173,61.5C.1,60.94.058,60.379.011,59.818A1.679,1.679,0,0,1,.26,58.666a1.231,1.231,0,0,1,1.246-.54,1.214,1.214,0,0,1,1,.806c.239.58.439,1.177.7,1.745A1.974,1.974,0,0,1,3.4,61.9a3.252,3.252,0,0,0,.869,2.556c.444.568.93,1.1,1.4,1.652a1.443,1.443,0,0,0,.181.178.442.442,0,1,0,.62-.629c-.431-.5-.876-.978-1.3-1.478a3.717,3.717,0,0,1-.9-1.659,1.385,1.385,0,0,1,1.048-1.668.94.94,0,0,1,.979.341c.936,1.134,1.835,2.3,2.81,3.4a8.95,8.95,0,0,1,2.171,5.169c.141,1.341.164,2.7.23,4.045a.607.607,0,0,1-.634.616c-.667.01-1.334,0-2,0v0",
    transform: "translate(0 -51.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35728",
    "data-name": "Path 35728",
    d: "M125.461,73.931c-.667,0-1.335,0-2,0a.585.585,0,0,1-.624-.615,28.5,28.5,0,0,1,.281-4.4A8.713,8.713,0,0,1,124.2,65.63c.571-.876,1.266-1.672,1.92-2.492.591-.74,1.218-1.451,1.795-2.2a1.06,1.06,0,0,1,1.13-.5,1.259,1.259,0,0,1,.983.869,1.816,1.816,0,0,1-.313,1.678c-.472.662-1.025,1.267-1.543,1.9-.119.145-.251.281-.356.435a.426.426,0,0,0,.638.556q.533-.54,1.035-1.112a6.06,6.06,0,0,0,1.333-2.031,2.794,2.794,0,0,0,.07-1.633.851.851,0,0,1,.088-.472c.272-.7.559-1.384.837-2.077a1.355,1.355,0,0,1,1.379-.855,1.25,1.25,0,0,1,1.13,1.265,16.484,16.484,0,0,1-.173,2.213c-.205,1.319-.438,2.636-.722,3.94a7.084,7.084,0,0,1-1.3,3.1,19.483,19.483,0,0,1-2,1.973,18.924,18.924,0,0,1-1.554,1.2,1.061,1.061,0,0,0-.475.932c.005.32.007.639,0,.959a.606.606,0,0,1-.673.656c-.658,0-1.316,0-1.974,0",
    transform: "translate(-108.956 -51.163)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "spa_FILL1_wght600_GRAD0_opsz48",
    d: "M12.471,20.89A10.074,10.074,0,0,1,3.25,10.567a10.748,10.748,0,0,1,3.822.637,7.3,7.3,0,0,1,2.85,1.911,8.824,8.824,0,0,1,1.814,3.218,16.138,16.138,0,0,1,.734,4.556Zm1.641-.432q-.108-1.6-.335-2.969a11.393,11.393,0,0,0-.594-2.3,8.027,8.027,0,0,1,3.261-3.477,7.937,7.937,0,0,1,4.729-1.188,12.168,12.168,0,0,1-2.084,6.457A9.591,9.591,0,0,1,14.112,20.458ZM12.19,13.439a8.992,8.992,0,0,0-1.382-1.792,8.732,8.732,0,0,0-1.9-1.339A13.49,13.49,0,0,1,10,6.421a16.1,16.1,0,0,1,2.17-3.671A16.074,16.074,0,0,1,14.4,6.432a12.681,12.681,0,0,1,1.112,3.984,5.292,5.292,0,0,0-1.825,1.177A9.215,9.215,0,0,0,12.19,13.439Z",
    transform: "translate(1214.182 721.336)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWellnessbeauty);
export default __webpack_public_path__ + "static/media/ic-wellness&beauty.3aced997ccb4a3b9642e2b935aea3ddb.svg";
export { ForwardRef as ReactComponent };